import { OrderStatusEnum } from "../order-status.enum";

export const DELIVERY_RELEVANT_STATUSES = [
    OrderStatusEnum.RECEIVED_IN_US_WAREHOUSE,
    OrderStatusEnum.AIR_SHIPPED_FROM_US,
    OrderStatusEnum.RECEIVED_IN_TBILISI_WAREHOUSE,
    OrderStatusEnum.SEND_TO_REGION,
    OrderStatusEnum.OUT_FOR_DELIVERY,
    OrderStatusEnum.FAILED_DELIVERY,
    OrderStatusEnum.DELIVERED,
];

/**
 * Returns the relevant status for delivery progress (same logic as delivery component).
 * Uses the first matching status in the list (assumes statuses order matches component expectations).
 */
export function getLastRelevantStatus(statuses) {
    if (!statuses?.length) return null;
    return statuses.find((s) => DELIVERY_RELEVANT_STATUSES.includes(s.status)) ?? null;
}

const STATUS_TO_PROGRESS_INDEX = {
    [OrderStatusEnum.DELIVERED]: 12,
    [OrderStatusEnum.FAILED_DELIVERY]: 11,
    [OrderStatusEnum.OUT_FOR_DELIVERY]: 10,
    [OrderStatusEnum.SEND_TO_REGION]: 8,
    [OrderStatusEnum.RECEIVED_IN_TBILISI_WAREHOUSE]: 6,
    [OrderStatusEnum.AIR_SHIPPED_FROM_US]: 4,
    [OrderStatusEnum.RECEIVED_IN_US_WAREHOUSE]: 1,
};

/**
 * Returns progress index (0-12) for the delivery track UI.
 */
export function getProgressIndexFromStatus(status) {
    if (status == null) return 0;
    return STATUS_TO_PROGRESS_INDEX[status] ?? 0;
}
